import React from "react";
import park1 from "@/assets/1.png";
import park2 from "@/assets/2.png";
import park3 from "@/assets/3.png";
import park4 from "@/assets/4.png";
import park5 from "@/assets/5.png";
import park6 from "@/assets/6.png";
import park7 from "@/assets/7.png";
import park8 from "@/assets/8.png";
import park9 from "@/assets/9.png";
import park10 from "@/assets/10.png";
import { t } from "@/i18n/translations";

const PARKS = [
  { abbr: "ANPI", name: "Aggteleki", logo: park1, accent: "#FBD556" },
  { abbr: "BFNPI", name: "Balaton-felvidéki", logo: park2, accent: "#A1E1B9" },
  { abbr: "BNPI", name: "Bükki", logo: park3, accent: "#FF9456" },
  { abbr: "DDNPI", name: "Duna-Dráva", logo: park4, accent: "#A1E1B9" },
  { abbr: "DINPI", name: "Duna-Ipoly", logo: park5, accent: "#FBD556" },
  { abbr: "FHNPI", name: "Fertő-Hanság", logo: park6, accent: "#A1E1B9" },
  { abbr: "HNPI", name: "Hortobágyi", logo: park7, accent: "#FF9456" },
  { abbr: "KNPI", name: "Kiskunsági", logo: park8, accent: "#FBD556" },
  { abbr: "KMNPI", name: "Körös-Maros", logo: park9, accent: "#FF9456" },
  { abbr: "ŐNPI", name: "Őrségi", logo: park10, accent: "#A1E1B9" },
];

const ParkBadge = ({ name, abbr, logo, accent, nemzetiParkLabel }) => (
  <div
    className="shrink-0 flex items-center gap-4 px-6 py-4 rounded-2xl border border-white/8 bg-[#1E1E1E]/60 hover:border-[#FBD556]/40 transition-colors"
    data-testid={`park-badge-${abbr.toLowerCase()}`}
  >
    <div
      className="w-14 h-14 rounded-full flex items-center justify-center border-2 shrink-0 overflow-hidden"
      style={{ borderColor: accent, backgroundColor: `${accent}14` }}
      aria-hidden="true"
    >
      <img src={logo} alt="" className="w-10 h-10 object-contain" />
    </div>
    <div className="leading-tight min-w-0">
      <div
        className="text-xs font-bold tracking-[0.18em] uppercase"
        style={{ color: accent }}
      >
        {abbr}
      </div>
      <div className="text-sm font-semibold text-[#FDF5EB] whitespace-nowrap">
        {name}
      </div>
      <div className="text-[10px] text-[#FDF5EB]/40 uppercase tracking-wider">
        {nemzetiParkLabel}
      </div>
    </div>
  </div>
);

const ParksCarousel = ({ lang }) => {
  const loop = [...PARKS, ...PARKS];
  const nemzetiParkLabel = t(lang, "partners.nemzetiPark");

  return (
    <section
      id="partners"
      data-testid="section-partners"
      className="py-20 lg:py-24 bg-[#141414] border-y border-white/5 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 mb-10">
        <div className="reveal inline-flex items-center gap-2 mb-3">
          <span className="h-px w-8 bg-[#A1E1B9]" />
          <span className="text-xs font-bold tracking-[0.2em] uppercase text-[#A1E1B9]">
            {t(lang, "partners.eyebrow")}
          </span>
        </div>
        <h2
          className="reveal reveal-delay-1 text-2xl sm:text-3xl lg:text-4xl font-bold text-[#FDF5EB] tracking-tight"
          data-testid="partners-heading"
        >
          {t(lang, "partners.heading")}
        </h2>
      </div>

      <div
        className="relative reveal reveal-delay-2"
        data-testid="parks-marquee"
        aria-label="Hungarian National Park partners carousel"
      >
        <div className="pointer-events-none absolute top-0 bottom-0 left-0 w-24 z-10 bg-gradient-to-r from-[#141414] to-transparent" />
        <div className="pointer-events-none absolute top-0 bottom-0 right-0 w-24 z-10 bg-gradient-to-l from-[#141414] to-transparent" />

        <div className="marquee-track flex items-center gap-4 w-max">
          {loop.map((p, i) => (
            <ParkBadge
              key={`${p.abbr}-${i}`}
              abbr={p.abbr}
              name={p.name}
              logo={p.logo}
              accent={p.accent}
              nemzetiParkLabel={nemzetiParkLabel}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ParksCarousel;
